// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-6Kx","label":"styles_label__3QLY6"};